import { render, staticRenderFns } from "./DataSetAddFileDialog.vue?vue&type=template&id=46647045&scoped=true"
import script from "./DataSetAddFileDialog.vue?vue&type=script&lang=js"
export * from "./DataSetAddFileDialog.vue?vue&type=script&lang=js"
import style0 from "./DataSetAddFileDialog.vue?vue&type=style&index=0&id=46647045&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46647045",
  null
  
)

export default component.exports